export default __webpack_public_path__ + "static/media/Kuncevic.fc59d813.png";